import React from "react";
import { observer } from "mobx-react";
import { withStyles } from "@material-ui/styles";
import { toJS } from "mobx";
import { withAlert } from "react-alert";
import Layout from "../../components/Layout";
import Ipinfo from "./ipinfo";
import IpList from "./ipList";
import { Grid } from "@material-ui/core";
import store from "../../stores/ipStore";
import '../../styles/ip.css';
const styles = (theme) => ({
  tableContainer: {
    marginTop: 20,
  },
});

const View = observer(
  class Init extends React.Component {
    render() {
      const { classes } = this.props;
      const ip = toJS(store);
      return (
        <Layout>
          <Grid container spacing={3}>
            <div class='ipStatus'>
              <IpList store={ip} />
            </div>
            <div class='ipAddr'>
              <Ipinfo
                subnet="255.255.255.224"
                gateway="211.41.176.94"
                dns="218.36.109.2"
                dns2="168.126.63.1"
                class='ipInfo'
                />
            </div>
          </Grid>
        </Layout>
      );
    }
  }
);

const alertView = withAlert()(View);
export default withStyles(styles)(alertView);
